define.alias("shared/components/shared/user/info", "preview-grid/components/shared/user/info");